import { render, staticRenderFns } from "./DashLitigation.vue?vue&type=template&id=3cc5b698&scoped=true&"
import script from "./DashLitigation.vue?vue&type=script&lang=js&"
export * from "./DashLitigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc5b698",
  null
  
)

export default component.exports